var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.00009C14 1.54832 13.6971 1.15265 13.261 1.03475C12.8249 0.916842 12.3639 1.10599 12.1362 1.49622L5.13622 13.4962C4.9558 13.8055 4.95452 14.1877 5.13286 14.4982C5.3112 14.8086 5.64193 15.0001 6 15.0001H10V22.0001C10 22.4519 10.3029 22.8475 10.739 22.9654C11.1751 23.0833 11.6361 22.8942 11.8638 22.504L18.8638 10.504C19.0442 10.1947 19.0455 9.81252 18.8671 9.50203C18.6888 9.19154 18.3581 9.00009 18 9.00009H14V2.00009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildIcon);
export default __webpack_public_path__ + "static/media/build-icon.a3d9e553fe71a77a4fa30e965e242fdd.svg";
export { ForwardRef as ReactComponent };